/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, isEmpty, find } from "lodash";
import {
  IconButton,
  Pagination,
  Stack,
  Chip,
  Menu,
  MenuItem,
  Link as LinkMui,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link } from "react-router-dom"

import Layout from "../../../../components/layout/Layout"
import Table from "../../../../components/form/TableFilter";
import Toolbar from "./Toolbar";
import Notification from "../../../../components/form/Notification";
import Alert from "../../../../components/form/Alert";
import { PageSize, countPage } from "../../../../config/const"

import { getProvider } from "../../../../store/masters/thunk/provider/getAll";
import { getCodeOdoo } from "../../../../store/masters/thunk/provider/getAllOdoo";
import { getClientsRoute } from "../../../../store/transactions/thunk/clientsRoutes/getAll";

const Providers = () => {
  const [__] = useTranslation("supplierMaster");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

  const provider = useSelector(state => state.masters.provider);
  const put = useSelector(state => state.masters.provider.put);

  const odooCode = useSelector(state => state.masters.provider.codesOdoo);

  const optionsCodeOdoo = map(odooCode?.data?.result,({ id, name }) => ({
    value: id,
    label: name
}))
  //const delet = useSelector(state => state.masters.provider.delete);

  const getData = ({page, filters = filter}) => {
    dispatch(getProvider({page, ...filters, Export: false}))
    dispatch(getCodeOdoo());
    dispatch(getClientsRoute({ Export: false }));
  }

  const reload = () => getData({ page: 1 })

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1})
  }, []);

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getData({ page: 1, filters: updatedFilters });
  };

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    // if (get(delet, "isSuccess", false)) { handleCloseMenu(); getData({ page: 1, filter }); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    // if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { handleCloseMenu(); getData({ page: 1, filter }); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [put])

  //}, [put, delet])

  const headTable = [
    {
      key: "status",
      label: __(`table.cols.status`),
      align: "center"
    },
    {
      key: "code",
      label: __(`table.cols.idSupplier`),
      align: "center"
    },
    {
      key: "comercialName",
      label: __(`table.cols.commercialName`),
      align: "center"
    },
    {
      key: "legalName",
      label: __(`table.cols.companyName`),
      align: "center"
    },
    {
      key: "municipality",
      label: __(`table.cols.department`),
      align: "center"
    },
    {
      key: "providerOdooId",
      label: __(`table.cols.odooCode`),
      align: "center"
    },
    // {
    //   key: "options",
    //   label: __(`table.cols.options`),
    //   align: "center",
    //   sx: { position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    // },
  ]

  const dataTable = map(get(provider, "data.data", []), (row, i) => ({
    ...row,
    code: <LinkMui component={Link} to={toString(get(row, "id"))} >{get(row, "id")}</LinkMui>,
    status: <Chip label={get(row, "isActive") === true ? __("Activo") : __("Inactivo")} color={get(row, "isActive") === true ? "success" : "error"}/>,
    providerOdooId: get(find(optionsCodeOdoo, {value: get(row, "providerOdooId")}), "label")
    // options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(provider, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(provider, "isLoading", false) || get(odooCode, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(provider, "data.totalRecord", 1))}
          page={get(provider, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(provider, "isLoading", false)}
        />
      </Stack>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <Link to={toString(get(selected, "idClient"))}><MenuItem >{__(`table.menu.edit`)}</MenuItem></Link>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </Layout>
  )
}

export default Providers;


